<template>
  <b-table
    :items="items"
    :fields="fields"
    fixed
    :busy="isBusy"
    bordered
    responsive
    sm="4"
  >
    <template #table-busy>
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>
    <template #cell(Veranstalter)="data">
      <b-row>
        <b-col md="10"><span v-html="data.value"> </span></b-col>
      </b-row>
    </template>
    <template #cell(Excerpt)="data">
      <a @click="data.toggleDetails">
        <b-row>
          <b-col md="10"><span v-html="data.value"> </span></b-col>
          <b-col v-if="!data.detailsShowing" md="2"><b-icon icon="chevron-down" /></b-col>
          <b-col v-if="data.detailsShowing" md="2"><b-icon icon="chevron-up" /></b-col>

        </b-row>
      </a>
    </template>
    <template #row-details="row">
      <b-card >
        <b-row>
          <b-col md="6"> <b-img :src="row.item.image" fluid /></b-col>

          <b-col md="6"><span v-html="row.item.Angebot"> </span></b-col>
        </b-row>
      </b-card>
    </template>
  </b-table>
</template>

<script>
export default {
  props: {
    posts: Array,
    isBusy: Boolean,
  },

  data() {
    return {
      fields: [
        { key: "Veranstalter", label: "Veranstalter", variant: "stjawhite" },
        { key: "Excerpt", label: "Angebot", variant: "primarystja" },
      ],
      items: [],
    };
  },

  methods: {
    toggleDetails(row) {
      row.toggleDetails()
    }
  },
  watch: {
    isBusy: function (val) {
    },

    posts: function (val) {
      this.items = [];
      val.forEach((element) => {
        this.items.push({
          isActive: false,
          Veranstalter: element.title.rendered,
          Excerpt: element.excerpt.rendered,
          image: element._embedded["wp:featuredmedia"]["0"].source_url,
          Angebot: element.content.rendered,
        });
      });
    },
  },
};
</script>


<style >
.mybutton {
  display: none;
}

.button {
  float: right;
  height: unset;
  position: relative !important;
}

image {
  max-width: 80px !important;
}

.thead-tr-danger {
  background-color: red;
}

table.b-table[aria-busy="true"] {
  opacity: 0.6;
}

tbody > tr > td > a > div > div > span > p {
  margin: 0 !important;
}

.table-stjawhite {
  padding: 0 !important;
  padding-left: 15px !important;
  text-align: left;
  vertical-align: middle !important;
}

.table-primarystja {
  text-align: left;
  padding: 0 !important;
  padding-left: 15px !important;
}

th.table-stjawhite > div:nth-child(1) {
  padding-top: 15px;
  padding-bottom: 15px;
}

th.table-primarystja > div:nth-child(1) {
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/AngTabelle.vue